import { trackAuctionAddModalShow } from './modal-auction-add.tracking';

const SERVICE_MAP = {
  premium: 'Премиум-объявления',
  'premium+highlight': 'Премиум-объявления',
  top3: 'Топ-объявления',
  paid: 'Платные объявления',
}

export default [
  'placingTermsApi', '$scope', 'deviceService',
  function (placingTermsApi, $scope, deviceService) {
    $scope.isMobile = deviceService.isMobile;

    const { stepBet, selected } = placingTermsApi;
    const option = selected && selected.option;

    $scope.betStep = stepBet;
    $scope.serviceName = option && SERVICE_MAP[option.id] || 'Премиум-объявления';

    trackAuctionAddModalShow();
  }
];
